import type { OnboardingProfileData, StepValidationResult } from "./types";

const websiteRegex = /^https?:\/\/.+/i;

const createResult = (errors: Record<string, string>): StepValidationResult => ({
  isValid: Object.keys(errors).length === 0,
  errors,
});

export function validateBasics(data: OnboardingProfileData): StepValidationResult {
  const errors: Record<string, string> = {};
  if (!data.organizationType) errors.organizationType = "This field is required.";
  const organizationName = data.organizationName.trim();
  if (!organizationName) {
    errors.organizationName = "This field is required.";
  } else if (organizationName.length < 2) {
    errors.organizationName = "Enter at least 2 characters.";
  }
  if (!data.country.trim()) errors.country = "This field is required.";
  if (!data.postcode.trim()) errors.postcode = "This field is required.";
  if (!data.operatingScope) errors.operatingScope = "This field is required.";
  return createResult(errors);
}

export function validateCoreProfile(data: OnboardingProfileData): StepValidationResult {
  const errors: Record<string, string> = {};
  const whatWeDo = data.whatWeDo.trim();
  if (!whatWeDo) {
    errors.whatWeDo = "This field is required.";
  } else if (whatWeDo.length < 10) {
    errors.whatWeDo = "Enter at least 10 characters.";
  }
  if (!data.operatingYears) {
    errors.operatingYears = "This field is required.";
  }
  if (!data.annualTurnoverBand) {
    errors.annualTurnoverBand = "This field is required.";
  }
  if (!data.primaryBeneficiaries.length) {
    errors.primaryBeneficiaries = "This field is required.";
  }
  return createResult(errors);
}

export function validateStrategicFocus(data: OnboardingProfileData): StepValidationResult {
  const errors: Record<string, string> = {};
  if (data.focusThemes.length < 1) {
    errors.focusThemes = "This field is required.";
  }
  if (data.focusThemes.length > 5) {
    errors.focusThemes = "Choose up to five focus themes so matches stay focused.";
  }
  return createResult(errors);
}

export function validateFundingGoals(data: OnboardingProfileData): StepValidationResult {
  const errors: Record<string, string> = {};
  if (!data.fundingTypes.length) errors.fundingTypes = "This field is required.";
  if (!data.fundingAmountBand) errors.fundingAmountBand = "This field is required.";
  if (!data.fundingTimeline) errors.fundingTimeline = "This field is required.";
  return createResult(errors);
}

export function validateBoostMatches(data: OnboardingProfileData): StepValidationResult {
  const errors: Record<string, string> = {};
  if (data.websiteUrl && !websiteRegex.test(data.websiteUrl.trim())) {
    errors.websiteUrl = "Use a full URL starting with http:// or https://";
  }
  return createResult(errors);
}

export function validateStep(
  stepId: string,
  data: OnboardingProfileData
): StepValidationResult {
  switch (stepId) {
    case "basics":
      return validateBasics(data);
    case "coreProfile":
      return validateCoreProfile(data);
    case "strategicFocus":
      return validateStrategicFocus(data);
    case "fundingGoals":
      return validateFundingGoals(data);
    case "boostMatches":
      return validateBoostMatches(data);
    default:
      return createResult({});
  }
}
